import React from 'react'
import './MonthView.styles.scss'

export default function MonthHeader() {
  let daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  return (
    <div className="month-row days_in_week " style={{flex: '0 0 29px'}}>
      {daysInWeek.map(day => {
        return <div className="ap-typography ap-typography--sm week_day">{day}</div>
      })}
    </div>
  )
}
